import React from 'react'
import styled from 'styled-components'
import {fonts, color, mediaQueries} from "../shared/config"

function InfluentialSneakerContent(props) {
    const { headerPos, sneakerName, sneakerImgURL, credits } = props;
    let leftRet = (<div><Header pos={headerPos}>{sneakerName}</Header>
        <ImageContainer>
            <Image pos={headerPos} src={sneakerImgURL}/>
        </ImageContainer>)</div>);
                                    
    return (
        <ThisBG>
        <Container>
            <HeaderContainer pos={headerPos}>
               
                 <div>
                  <Header pos={headerPos}>{sneakerName}</Header>
                    <ImageContainer>
                        <div>
                        <Image pos={headerPos} src={sneakerImgURL}/>
                        <Credits>{credits}</Credits>
                        </div>
                    </ImageContainer>
                </div>
                 
            </HeaderContainer>
            <Text>
                {props.text}
            </Text>
        </Container>
        </ThisBG>
    );
}

const Container = styled.div`
    width: 100%;
    padding: 0 8vw;
    ${mediaQueries.mobile} {
        width: 100%;
    }
`
const ThisBG = styled.div`
background-color: white;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    align-content: center;
    text-align: center;
    /* justify-content: ${props => props.pos === "right" ? "flex-end" : "flex-start"}; */
    ${mediaQueries.mobile} {
        justify-content: center;
        flex-direction: column;
    }
`

const Header = styled.h1`
    width: 100%;
    font-family: ${fonts.header};
    font-style: normal;
    font-weight: normal;
    color: black;
    text-align: ${props => props.pos === "right" ? "right" : "left"};
    padding-top: 20px;
    text-align: center;
    align-content: center;
    font-size: 70px;
    line-height: 75%;
    text-transform: uppercase;
    word-wrap: break-word;
    overflow-wrap: break-word;
    ${mediaQueries.mobile} {
        width: 100%;
        font-size: 40px;
        margin-top: 0px;
    }
`

const ImageContainer = styled.div`
    width: 100%;
    margin: -8em -2em 0 -2em;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    /* text-overflow:  */
    word-wrap: break-word;
    overflow-wrap: break-word;
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  text-align: right;
  padding-left: 10px;
  font-size: 12px;
  padding-right: 10px;
  ${mediaQueries.mobile} {
    text-align: right;
  }
  ${mediaQueries.tablet} {
    text-align: right;
  }
`;

const Image = styled.img`
    width: 90%;
    ${props => props.pos === "right"} {
        right: 0;
    }
    ${props => props.pos === "left"} {
        left: 0;
        
    }
    top: 0;
    /* position: absolute; */
    padding-top: 100px;
    margin-top: 80px;
    /* position: static; */
        width: 50%;
        height: 50%
    ${mediaQueries.mobile} {
        /* padding-top: 400px; */
        position: static;
        width: 80%;
        height: 80%
    }
`;

const Text = styled.p`
    font-family: ${fonts.text};
    color: black;
    line-height: 24px;
    font-size: 18px;
    text-align: left;
    padding: 6em 0;
    padding-bottom: 20px;
    
    margin: 0;
    /* margin-top: 10px; */
    padding-top: 120px;
    ${mediaQueries.mobile} {
        padding: 2em 0;
    }
`;

export default InfluentialSneakerContent
